import { CellStyle } from 'xlsx-js-style/types';
import { ColumnsWidths } from '../../utils';

/* eslint-disable @typescript-eslint/naming-convention */
export function getColumnsWidths(selectedPeriod: Date): ColumnsWidths[] {
  const selectedPeriodObj = {};
  selectedPeriodObj[selectedPeriod.toString()] = 100;
  const columnWidths = [{ '': 180 }, { MOIC: 80 }, { IRR: 80 }, selectedPeriodObj];
  return columnWidths;
};
/* eslint-enable @typescript-eslint/naming-convention */

export const totalStyle: CellStyle = {
  fill: {
    patternType: 'solid',
    fgColor: { rgb: 'F2F2F2' },
    bgColor: { rgb: 'F2F2F2' },
  },
  font: {
    bold: true,
  },
};

export const grandTotalStyle: CellStyle = {
  border: {
    top: { color: { rgb: '#000000' } },
    bottom: { color: { rgb: '#000000' }, style: 'thick' },
  },
  fill: {
    patternType: 'solid',
    fgColor: { rgb: 'F2F2F2' },
    bgColor: { rgb: 'F2F2F2' },
  },
  font: {
    bold: true,
  },
};
